import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import GoogleButton from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";

export default function SignIn() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      if (res.user.role === "admin" || res.user.role === "moderator") navigate("/admin/moderation");
      else navigate(res.user.onboarding?.completed ? "/community" : "/onboarding");
    } else setError(res.error);
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to rejoin the conversation."
      footer={<>New here? <Link to="/join" className="text-teal font-semibold">Join the Circle</Link></>}>
      <GoogleButton label="Sign in with Google" />
      <div className="flex items-center gap-4 my-6">
        <span className="h-px flex-1 bg-rose/50" /><span className="text-sm text-mutedplum">or</span><span className="h-px flex-1 bg-rose/50" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="signin-form">
        <div>
          <label className="block text-sm font-semibold text-plum mb-1.5">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signin-email"
            className="w-full rounded-2xl border-2 border-rose/50 bg-white px-4 py-3 outline-none focus:border-teal transition-colors" />
        </div>
        <div>
          <label className="block text-sm font-semibold text-plum mb-1.5">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signin-password"
            className="w-full rounded-2xl border-2 border-rose/50 bg-white px-4 py-3 outline-none focus:border-teal transition-colors" />
        </div>
        {error && <p className="text-sm text-red-500" data-testid="signin-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="signin-submit"
          className="w-full rounded-full bg-teal px-6 py-3.5 font-semibold text-white hover:bg-teal-dark transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </AuthShell>
  );
}
